export default __webpack_public_path__ + "static/media/profile.30038340.png";